import { FindAndReplace } from '../types';
import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';
import React from 'react';
import ReceiptItem from './ReceiptItem';
import Form from '../../../../../kingpin/forms/Form';
import FormHeader from '../../../../../kingpin/forms/FormHeader';
import FormContent from '../../../../../kingpin/forms/FormContent';
import List from '../../../../../components/List';

const ReceiptDetails = ({
  close,
  receipt,
}: {
  close: () => void;
  receipt: FindAndReplace.EnrichedMetricReceipt;
}) => {
  return (
    <Form>
      <FormHeader title={'Affected content'} onClose={close} />
      <FormContent>
        <List
          Headers={null}
          Body={
            <div style={{ margin: 16 }}>
              <ReceiptItem
                type={'Boards'}
                contentDetailsList={receipt.affectedContent.boards}
              />
              <ReceiptItem
                type={'Chart Definitions'}
                contentDetailsList={receipt.affectedContent.chartDefinitions}
              />
              <ReceiptItem
                type={'Dashboard Gadgets'}
                contentDetailsList={receipt.affectedContent.dashboardGadgets}
              />
              <ReceiptItem
                type={'Goals'}
                contentDetailsList={receipt.affectedContent.goals}
              />
              <ReceiptItem
                type={'Scorecards'}
                contentDetailsList={receipt.affectedContent.scorecards}
              />
            </div>
          }
        />
      </FormContent>
    </Form>
  );
};
const Gate = ({
  isOpen,
  close,
  receipt,
}: {
  isOpen: boolean;
  close: () => void;
  receipt: FindAndReplace.EnrichedMetricReceipt;
}) => (
  <ModalTransition>
    {isOpen && (
      <ModalDialog
        onClose={close}
        shouldScrollInViewport={false}
        autoFocus={false}
      >
        <ReceiptDetails receipt={receipt} close={close} />
      </ModalDialog>
    )}
  </ModalTransition>
);

export default Gate;
